import { ThemeProvider, Box, Typography } from "@mui/material"
import { theme } from "@ikhokha/commons-ui"
import warningAmberOutlined from "../assets/icons/WarningAmberOutlined.svg"
import closeFilled from "../assets/icons/CloseFilled.svg"
import { useState } from "react"

export default function ErrorBanner({ error, errors }) {
	const [closeBanner, setCloseBanner] = useState(false)
	const handleCloseBanner = () => {
		setCloseBanner(true)
	}
	return !closeBanner ? (
		<ThemeProvider theme={theme}>
			<Box
				sx={{
					borderRadius: "8px",
					background: "#FCE4E9",
					width: "100%",
					marginTop: theme.spacing(3),
					display: "flex",
					padding: theme.spacing(2),
					boxSizing: "border-box",
					color: "#000",
					flexShrink: 0,
				}}
			>
				<Box>
					<img src={warningAmberOutlined} alt="warning" />
				</Box>
				<Box
					sx={{
						width: "100%",
						display: "flex",
						flexDirection: "column",
						marginLeft: theme.spacing(1),
						marginRight: theme.spacing(1),
						wordBreak: "break-word",
						whiteSpace: "normal",
					}}
				>
					<Typography variant="subtitle2">{error || errors[0]}</Typography>
				</Box>
				<Box onClick={handleCloseBanner}>
					<img src={closeFilled} alt="close" />
				</Box>
			</Box>
		</ThemeProvider>
	) : (
		<></>
	)
}
